import React from 'react';
import { ArrowIcon, Button } from 'fronton-react';
import { GAClickButton } from 'utils/analytics/analytics-events';
import { ButtonNextStyle, ButtonPrevStyle, CommonButtonStyles } from './styles';

type SliderButtonProps = {
	type: 'prev' | 'next';
	dataQa?: string;
};

export const SliderButton = ({ type, dataQa = '' }: SliderButtonProps) => {
	const isNext = type === 'next';
	const handleSwiperBtnClick = () => {
		GAClickButton({
			elementBlock: 'servicePage / popular',
			elementName: isNext ? 'switch-forward' : 'switch-backward',
			elementText: 'Популярные услуги',
		});
	};

	const btnClassName = isNext
		? `${ButtonNextStyle} swiper-button--next`
		: `${ButtonPrevStyle} swiper-button--prev`;

	return (
		<Button
			aria-label="icon"
			iconOnly
			kind="regular"
			rounded
			size="l"
			variant="outline"
			style={{
				backgroundColor: '#fff',
			}}
			onClick={handleSwiperBtnClick}
			className={`${CommonButtonStyles} ${btnClassName}`}
			data-qa={dataQa}
		>
			<ArrowIcon direction={isNext ? 'right' : 'left'} />
		</Button>
	);
};
